var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ui-tile"},[_c('div',{staticClass:"card"},[_c('figure',{staticClass:"front"},[_c('img',{attrs:{"src":_vm.flippedUrl}})]),_c('figure',{staticClass:"back"},[_c('img',{attrs:{"src":_vm.unflippedUrl}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }